import Material from "./material";
import vertexShaderSrc from './shaders/vertex.vert';
export default class GLPass{
    constructor({gl, geometry, fragment, uniforms}) {
        this.gl = gl;
        this.geometry = geometry;
        this.material = new Material(this.gl,{
            vertexShader: vertexShaderSrc,
            fragmentShader: fragment,
            uniforms: {
                resolution:{
                    name: "u_resolution",
                    type: "f",
                    size: 2
                },
                time:{
                    name: "u_time",
                    type: "f",
                    size: 1
                },
                sampler: {
                    name: "u_sampler",
                    type: "t",
                },
                ...uniforms
            }
        });

        this.createFramebuffer(this.gl);
    }

    resize(w,h){
        const gl = this.gl;
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, w, h, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
    }

    createFramebuffer(gl, w, h){
        this.texture = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, this.texture);
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, null);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);

        this.framebuffer = gl.createFramebuffer();
        gl.bindFramebuffer(gl.FRAMEBUFFER, this.framebuffer);
        gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, this.texture, 0);
    }

    render(final){   
        this.gl.bindFramebuffer(this.gl.FRAMEBUFFER, final ? null : this.framebuffer);
        this.gl.clear(this.gl.COLOR_BUFFER_BIT | this.gl.DEPTH_BUFFER_BIT);
  
        this.gl.bindBuffer(this.gl.ARRAY_BUFFER, this.geometry);
        this.gl.enableVertexAttribArray(this.material.attributes.vertexPosition);
        this.gl.vertexAttribPointer(this.material.attributes.vertexPosition, 2, this.gl.FLOAT, false, 0, 0);
        this.material.use();
        this.gl.drawArrays(this.gl.TRIANGLE_STRIP, 0, 4);
    }
}

  